<template>
    <div :class="!loaded ? `skeleton-box ${classNamesBox}` : classNamesBox" :style="!loaded ? loadingStyles : {}" 
        v-observe-visibility="{
            callback: visibilityChanged,
            once: true,
            intersection:{
                rootMargin: `${marginH}px ${marginW}px ${marginH}px ${marginW}px`,
                threshold: 0
            }
        }">
        <picture v-show="loaded">
            <source type="image/webp" :srcset="srcSetWebp ? `${srcImgWebp}, ${srcSetWebp} 2x` : srcImgWebp" v-if="srcImgWebp">
            <source type="image/jpeg" :srcset="srcSet ? `${srcImg}, ${srcSet} 2x` : srcImg" v-if="srcImg != ''">
            <img :class="classNames" :src="srcImg" @load="imgLoad" @error="error" :alt="title" />
        </picture>
    </div>
</template>
<script>
import utilities from '@/Utilities/common';
export default {
    name: 'BlockImage',
    props:{
        image: {
            type: String,
            default: ''
        },
        imageSrcSet: {
            type: String,
            default: null
        },
        classNames:{
            type: String,
            default: null
        },
        classNamesBox:{
            type: String,
            default: null
        },
        loadingStyles:{
            type: Object,
            default: () => {
                return {};
            }
        },
        isScrolled:{
            type: Boolean,
            default: false
        },
        webpAllowed:{
            type: Boolean,
            default: true
        },
        height:{
            type: Number,
            default: 0
        },
        width:{
            type: Number,
            default: 0
        },
        title:{
            type: String,
            default: null
        }
    },
    data(){
        return {
            isLoaded: false,
            isVisible: false,
            ignoreWebp: false,
        }
    },
    created(){
        this.isWebpAllowed = this.webpAllowed;
    },
    computed: {
        cookiebotAuth(){
            return utilities.cookiebotCheckAll() ? true : false;
        },
        isJpg(){
            return this.image && this.image.indexOf('.jpg') !== -1;
        },
        loaded(){
            return (this.isLoaded || !this.cookiebotAuth) && this.srcImg && this.srcImg != '';
        },
        srcImgWebp(){
            if(this.webpAllowed && !this.ignoreWebp && this.isJpg){
                return this.srcImg.replace('.jpg','.webp');
            }
            return null;
        },
        srcImg(){
            if(!this.isScrolled && !this.isVisible){
                return '';
            }
            return this.image;
        },
        srcSetWebp(){
            if(this.srcSet && this.webpAllowed && !this.ignoreWebp && this.isJpg){
                return this.srcSet.replace('.jpg','.webp');
            }
            return null;
        },
        srcSet(){
            if(!this.isScrolled && !this.isVisible){
                return null;
            }
            if(!this.imageSrcSet){
                return null;
            }
            return this.imageSrcSet;
        },
        marginW(){
            return this.width * 2;
        },
        marginH(){
            return this.height * 2;
        }
    },
    methods: {
        visibilityChanged(isVisible){
            if(isVisible){
                this.isVisible = true;
            }
        },
        error(e){
            if(!this.isScrolled && !this.isVisible){
                return;
            }
            this.ignoreWebp = true;
        },
        imgLoad(){ 
            this.isLoaded = true;
        }
    },
}
</script>
